import React from "react";
import styled, { css } from "styled-components";
import _ from "lodash";

import { Text } from "src/library/components/Text";
import { Select } from "src/library/components/Forms";

import {
  IPackSize,
  ProductWithPackSizes
} from "../../api/products.api";
import { useProductLatestPackSize } from "../../hooks/useProductLatestPackSize";

interface ProductPackSizeSelectorProps {
  product: ProductWithPackSizes;
  hideUnitQuantity?: boolean;
}

export const ProductPackSizeSelector: React.FC<ProductPackSizeSelectorProps> = ({ product, hideUnitQuantity }) => {
  const [ { packSize }, { setPackSize } ] = useProductLatestPackSize(product);

  const displayPackSize = React.useMemo(() => {
    return packSize?.code || product.unitCode || "unit";
  }, [ packSize?.code, product.unitCode ]);

  /**
   * Handle the pack size select box changing by setting packsize state
   */
  const handlePackSizeChange = React.useCallback((value: string) => {
    let newPackSize: IPackSize | null = null;

    if (product.packSizes) {
      newPackSize = product.packSizes.find(pack => pack.code === value) as IPackSize;
    }

    if (setPackSize) {
      setPackSize(newPackSize?.code || null);
    }
  }, [ product.packSizes, setPackSize ]);

  return (
    <PackSizeSelectorWrapper displayPackSize={displayPackSize}>
      <Select
        className="pack-size-selector-wrapper"
        as="select"
        name="packSize"
        label="Pack Size"
        autoHideLabels
        options={_.sortBy(product.packSizes, "quantity").map(packSize => ({
          text: packSize.name,
          value: packSize.code
        }))}
        value={packSize?.code || ""}
        handleChange={e => handlePackSizeChange(e.target.value)}
        unselectedOption={product.disableUnitOrdering ? undefined : {
          text: product.unitCode ? _.startCase(product.unitCode) : "Unit",
          value: product.unitCode || "unit"
        }}
      />

      {packSize && hideUnitQuantity !== true && packSize.quantity > 1 && (
        <div className="pack-quantity-label">
          <Text fontSize="sub">
            {`Contains ${packSize.quantity} ${product.unitCodePlural || "units"}`}
          </Text>
        </div>
      )}

    </PackSizeSelectorWrapper>
  );
};

const PackSizeSelectorWrapper = styled.div<{displayPackSize: string}>`${({ displayPackSize }) => css`
  .select.select {
    text-align: center;
    width: calc(55px + ${displayPackSize.length * 7}px); // dynamic get bigger
    min-width: 0px;
  }

  .pack-quantity-label {
    display: flex;
    justify-content: flex-end;
  }
`}`;
